// All config fields are nested under this namespace
export const ROOT_NAMESPACE = 'unifiedPolicy';

// Namespaces for policy type sub configs
export const NMS_NAMESPACE = `${ROOT_NAMESPACE}.nms`;
export const KEVENT_NAMESPACE = `${ROOT_NAMESPACE}.kevent`;
export const FLOW_NAMESPACE = `${ROOT_NAMESPACE}.flow`;

export const TARGET_TYPES = {
  ENTITY: 'entity',
  EVENT: 'event',
  CUSTOM: 'custom'
  // We handle these later, just add them as comments for now
  // DDOS: 'ddos',
  // CORE: 'core',
  // CLOUD: 'cloud'
};

export const FLOW_TARGET_TYPE_OPTIONS = [
  { value: 'core', label: 'Traffic' },
  { value: 'ddos', label: 'Protect' },
  { value: 'cloud', label: 'Cloud' }
];
